export const VIEW_FILTERS = [
  { id: 'all', labelKey: 'VIEW_FILTER_ALL' },
  { id: 'favorites', labelKey: 'VIEW_FILTER_FAVORITES' },
];

export const LETTER_FILTERS = [
  { id: 'all', labelKey: 'LETTER_FILTER_ALL' },
  { id: 'A', labelKey: 'LETTER_FILTER_A' },
  { id: 'B', labelKey: 'LETTER_FILTER_B' },
  { id: 'C', labelKey: 'LETTER_FILTER_C' },
  { id: 'E', labelKey: 'LETTER_FILTER_E' },
  { id: 'F', labelKey: 'LETTER_FILTER_F' },
  { id: 'G', labelKey: 'LETTER_FILTER_G' },
  { id: 'H', labelKey: 'LETTER_FILTER_H' },
  { id: 'I', labelKey: 'LETTER_FILTER_I' },
  { id: 'J', labelKey: 'LETTER_FILTER_J' },
  { id: 'M', labelKey: 'LETTER_FILTER_M' },
  { id: 'N', labelKey: 'LETTER_FILTER_N' },
  { id: 'P', labelKey: 'LETTER_FILTER_P' },
  { id: 'R', labelKey: 'LETTER_FILTER_R' },
  { id: 'S', labelKey: 'LETTER_FILTER_S' },
  { id: 'T', labelKey: 'LETTER_FILTER_T' },
  { id: 'U', labelKey: 'LETTER_FILTER_U' },
];
